import { AxiosInstance } from "axios";
import QueryString from "qs";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";
import { OrganizationDataRecipientDto } from "../dto/OrganizationDataRecipientDto";
import { OrganizationPublicId, UUIDString } from "../Types";
import { Operation } from "fast-json-patch";
import { DataRecipientsPatchResult } from "../../../../polaris/hooks/useDataRecipients";

export class DataRecipientController {
  constructor(private axios: AxiosInstance) {}

  public getDataRecipients = async (
    organizationId: OrganizationPublicId,
    excludeCategories?: String[],
    includeDataStorageLocations: boolean = false,
    excludeIncomplete: boolean | undefined = undefined,
  ): Promise<OrganizationDataRecipientDto[]> => {
    const url = Helpers.organizationDataRecipients(organizationId);
    const response = await this.axios.get<OrganizationDataRecipientDto[]>(url, {
      params: { excludeCategories, excludeIncomplete, includeDataStorageLocations },
      paramsSerializer: (q) => QueryString.stringify(q, { arrayFormat: "comma" }),
    });

    return response.data;
  };

  public patchDataRecipient = async (
    organizationId: OrganizationPublicId,
    vendorId: UUIDString,
    operations: Operation[],
  ): Promise<OrganizationDataRecipientDto> => {
    const url = Helpers.organizationDataRecipient(organizationId, vendorId);
    const response = await this.axios.patch<OrganizationDataRecipientDto>(url, operations);
    return response.data;
  };

  public patchDataRecipients = async (
    organizationId: OrganizationPublicId,
    params: {
      vendorIds: UUIDString[];
      operations: Operation[];
    },
  ): Promise<DataRecipientsPatchResult> => {
    const url = Helpers.organizationDataRecipients(organizationId);
    const response = await this.axios.patch<DataRecipientsPatchResult>(url, params);
    return response.data;
  };
}
